export default __webpack_public_path__ + "static/media/logo.514cbfc1.svg";